import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79fa1782"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Most people start by creating a group with "),
  /*#__PURE__*/_createElementVNode("b", null, "their parents"),
  /*#__PURE__*/_createTextVNode(" as the common ancestors. ")
], -1))
const _hoisted_2 = { class: "list-unstyled" }

import { ref } from 'vue'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { PatchChange } from '@/util/Api'
import { hideModalAsync } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'
import FamilyCard from '../FamilyCard.vue'
import { AsyncUtil } from '@/util/AsyncUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupScopeModal',
  props: {
    familyGroupId: {},
    candidateFamilyIds: {}
  },
  emits: [
  'selectNone'
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  open: () => modalRef.value?.open(),
})

const selectedFamilyIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const familyGroupStore = useFamilyGroupStore()

function onShown() {
  console.log(`FamilyGroupScopeModal: shown with candidates ${props.candidateFamilyIds}`)
  selectedFamilyIdRef.value = undefined
  if (props.candidateFamilyIds.length == 1) {
    selectedFamilyIdRef.value = props.candidateFamilyIds[0]
  }
}

function onSelected(familyId: string) {
  console.log(`FamilyGroupScopeModal: selected ${familyId}`)
  selectedFamilyIdRef.value = familyId
}

async function updateScope() {
  console.log(`FamilyGroupScopeModal: update scope to ${selectedFamilyIdRef.value}`)
  if (selectedFamilyIdRef.value) {
    const change = new PatchChange('/scopeFamilyId', selectedFamilyIdRef.value)
    const update = familyGroupStore.patchAsync(props.familyGroupId, [change])
    await AsyncUtil.atLeast(500, update)
    modalRef.value?.close()
  }
  else {
    await hideModalAsync(modalRef.value?.$el)
    emit('selectNone')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    onOk: updateScope,
    onShown: onShown,
    onSecondaryAction: updateScope
  }, {
    title: _withCtx(() => [
      _createTextVNode("Select common ancestors")
    ]),
    okText: _withCtx(() => [
      (_ctx.candidateFamilyIds.length == 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Use my parents ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Use selected parents ")
          ], 64))
    ]),
    secondaryText: _withCtx(() => [
      _createTextVNode("Select someone else")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidateFamilyIds, (vfId) => {
          return (_openBlock(), _createElementBlock("li", { key: vfId }, [
            _createVNode(FamilyCard, {
              "family-id": vfId,
              "select-mode": "",
              onClick: ($event: any) => (onSelected(vfId))
            }, null, 8, ["family-id", "onClick"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}
}

})